import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
    {
        id: "po-04-h2v2-01",
        name: "PO 01 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 13, y: 299, width: 185, height: 298, rotation: 0, imageRotation: 0 },
            { id: "2", x: 205, y: 299, width: 417, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 631, y: 299, width: 417, height: 298, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1055, y: 299, width: 185, height: 298, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-02",
        name: "PO 02 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 109, y: 120, width: 408, height: 656, rotation: 0, imageRotation: 0 },
            { id: "2", x: 664, y: 120, width: 549, height: 364, rotation: 0, imageRotation: 0 },
            { id: "3", x: 664, y: 491, width: 178, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 849, y: 491, width: 364, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-03",
        name: "PO 03 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 626, height: 894, rotation: 0, imageRotation: 0 },
            { id: "2", x: 707, y: 168, width: 462, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 707, y: 483, width: 149, height: 244, rotation: 0, imageRotation: 0 },
            { id: "4", x: 864, y: 483, width: 306, height: 244, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-04",
        name: "PO 04 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 39, y: 227, width: 273, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 320, y: 227, width: 273, height: 439, rotation: 0, imageRotation: 0 },
            { id: "3", x: 734, y: 150, width: 410, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 451, width: 410, height: 293, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-05",
        name: "PO 05 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 13, y: 299, width: 417, height: 298, rotation: 0, imageRotation: 0 },
            { id: "2", x: 437, y: 299, width: 185, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 630, y: 299, width: 185, height: 298, rotation: 0, imageRotation: 0 },
            { id: "4", x: 822, y: 299, width: 417, height: 298, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-06",
        name: "PO 06 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 84, y: 189, width: 717, height: 515, rotation: 0, imageRotation: 0 },
            { id: "2", x: 808, y: 189, width: 359, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 808, y: 451, width: 176, height: 255, rotation: 0, imageRotation: 0 },
            { id: "4", x: 991, y: 451, width: 176, height: 255, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-07",
        name: "PO 07 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 78, y: 170, width: 343, height: 554, rotation: 0, imageRotation: 0 },
            { id: "2", x: 428, y: 451, width: 395, height: 273, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 170, width: 395, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 831, y: 170, width: 343, height: 554, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-08",
        name: "PO 08 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 76, y: 166, width: 336, height: 542, rotation: 0, imageRotation: 0 },
            { id: "2", x: 419, y: 166, width: 336, height: 542, rotation: 0, imageRotation: 0 },
            { id: "3", x: 762, y: 166, width: 387, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 762, y: 441, width: 387, height: 267, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-09",
        name: "PO 09 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 256, y: 88, width: 487, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 88, width: 217, height: 345, rotation: 0, imageRotation: 0 },
            { id: "3", x: 256, y: 441, width: 217, height: 345, rotation: 0, imageRotation: 0 },
            { id: "4", x: 481, y: 441, width: 487, height: 345, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-10",
        name: "PO 10 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 61, y: 173, width: 372, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 451, width: 182, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 451, width: 182, height: 268, rotation: 0, imageRotation: 0 },
            { id: "4", x: 440, y: 173, width: 751, height: 547, rotation: 0, imageRotation: 0 }
        ],
    }
];